import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import Checkbox from "@/Shared/Form/Checkbox";

const CategotyCheckbox = ({ index, field, onRemoveCustom = () => {} }) => {
  const { control } = useFormContext();
  const category = field;
  
  return (
    <div className="d-flex align-items-center">
        <Controller
          name={`shareCollectInfo[${index}].value`}
          control={control}
          render={({ field: { onChange, value, ref, ...rest } }) => (
            <Checkbox
              name={category.id}
              label={category.label}
              checked={category.isCustom ? true : !!value}
              disabled={category.isCustom}
              onChange={(e) => {
                if (!category.isCustom) {
                  onChange(e.target.checked);
                }
              }}
              ref={ref}
              {...rest}
            />
          )}
        />
        {category.isCustom && onRemoveCustom && (
          <span className='ms-2 cursor-pointer' onClick={onRemoveCustom}>
            <i className='fas fa-minus-square text-danger fs-2' />
          </span>
        )}
      </div>
  )
}

export default CategotyCheckbox; 